import { render, staticRenderFns } from "./ASMMicrobe2026.vue?vue&type=template&id=2b8d1026&scoped=true"
import script from "./ASMMicrobe2026.vue?vue&type=script&lang=js"
export * from "./ASMMicrobe2026.vue?vue&type=script&lang=js"
import style0 from "./ASMMicrobe2026.vue?vue&type=style&index=0&id=2b8d1026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d1026",
  null
  
)

export default component.exports